// extracted by mini-css-extract-plugin
export default {"outer-container":"dashboard_outer-container__n3gsy","shade":"dashboard_shade__cQAjI"};